/**
 * @desc 获取url query参数
 * @param {String} query  想要获取的参数名字
 */
const getQueryString = function (url, query) {
  if (!url || !query) {
    return false
  }
  const reg = /[?&]([^=&#]+)=([^&#]*)/g
  const queryString = url.match(reg) || []
  for (let item of queryString) {
    const queryArray = item && item.substr(1).split('=')
    const resultKey = queryArray[0]
    const resultValue = queryArray[1]
    if (resultKey === query && resultValue) {
      return resultValue
    }
  }
}
export default getQueryString
